import request from 'superagent';

// Direct inspiration:
// https://github.com/jakemmarsh/react-rocket-boilerplate/blob/master/app/js/utils/APIUtils.js

const ApiUtil = {
  get(path, data = null, accessToken) {
    const token = accessToken;
    return new Promise((resolve, reject) => {
      request
        .get(path, data)
        .set('Authorization', `Bearer ${token}`)
        .set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains')
        .set('X-Frame-Options', 'deny')
        .set('X-Content-Type-Options', 'nosniff')
        .set('Content-Security-Policy', "script-src 'self'")
        .set('X-Permitted-Cross-Domain-Policies', 'none')
        .set('Referrer-Policy', 'no-referrer')
        .set('Clear-Site-Data', '"cache","cookies","storage"')
        .set('Cross-Origin-Embedder-Policy', 'require-corp')
        .set('Cross-Origin-Opener-Policy', 'same-origin')
        .set('Cross-Origin-Resource-Policy', 'same-origin')
        .set('Cache-Control', 'public, max-age=604800')
        .set('pub_group', window.getPublication())
        .end((err, res) => {
          if (err || !res.ok) {
            reject(err || res);
          } else {
            resolve(res);
          }
        });
    });
  },

  post(path, body, accessToken) {
    return new Promise((resolve, reject) => {
      const token = accessToken;
      request
        .post(path, body)
        .set('Authorization', `Bearer ${token}`)
        .set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains')
        .set('X-Frame-Options', 'deny')
        .set('X-Content-Type-Options', 'nosniff')
        .set('Content-Security-Policy', "script-src 'self'")
        .set('X-Permitted-Cross-Domain-Policies', 'none')
        .set('Referrer-Policy', 'no-referrer')
        .set('Clear-Site-Data', '"cache","cookies","storage"')
        .set('Cross-Origin-Embedder-Policy', 'require-corp')
        .set('Cross-Origin-Opener-Policy', 'same-origin')
        .set('Cross-Origin-Resource-Policy', 'same-origin')
        .set('Cache-Control', 'public, max-age=604800')
        .set('pub_group', window.getPublication())
        .end((err, res) => {
          if (err || !res.ok) {
            if (res.body && res.body.message) reject(res.body.message);
            else reject(err);
          } else {
            resolve(res);
          }
        });
    });
  },

  put(path, body, accessToken) {
    const token = accessToken;
    return new Promise((resolve, reject) => {
      request
        .put(path, body)
        .set('Authorization', `Bearer ${token}`)
        .set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains')
        .set('X-Frame-Options', 'deny')
        .set('X-Content-Type-Options', 'nosniff')
        .set('Content-Security-Policy', "script-src 'self'")
        .set('X-Permitted-Cross-Domain-Policies', 'none')
        .set('Referrer-Policy', 'no-referrer')
        .set('Clear-Site-Data', '"cache","cookies","storage"')
        .set('Cross-Origin-Embedder-Policy', 'require-corp')
        .set('Cross-Origin-Opener-Policy', 'same-origin')
        .set('Cross-Origin-Resource-Policy', 'same-origin')
        .set('Cache-Control', 'public, max-age=604800')
        .set('pub_group', window.getPublication())
        .end((err, res) => {
          if (err || !res.ok) {
            reject(err || res);
          } else {
            resolve(res);
          }
        });
    });
  },

  del(path, body, accessToken) {
    const token = accessToken;
    return new Promise((resolve, reject) => {
      request
        .del(path, body)
        .set('Authorization', `Bearer ${token}`)
        .set('Strict-Transport-Security', 'max-age=31536000; includeSubDomains')
        .set('X-Frame-Options', 'deny')
        .set('X-Content-Type-Options', 'nosniff')
        .set('Content-Security-Policy', "script-src 'self'")
        .set('X-Permitted-Cross-Domain-Policies', 'none')
        .set('Referrer-Policy', 'no-referrer')
        .set('Clear-Site-Data', '"cache","cookies","storage"')
        .set('Cross-Origin-Embedder-Policy', 'require-corp')
        .set('Cross-Origin-Opener-Policy', 'same-origin')
        .set('Cross-Origin-Resource-Policy', 'same-origin')
        .set('Cache-Control', 'public, max-age=604800')
        .set('pub_group', window.getPublication())
        .end((err, res) => {
          if (err || !res.ok) {
            reject(err || res);
          } else {
            resolve(res);
          }
        });
    });
  },
};

export default ApiUtil;
